<template>
  <div class="container-fluid customer-media-container">
    <b-card class="card-transparent-background card-overlay-spotify-container-dy mt-4" body-class="card-overlay-body">
      <b-row>
        <b-col xl="3" lg="4">
          <b-card class="
                                card-transparent-background card-spotify-playlist-info-dy
                                my-3
                              " :title="playlist_title" :sub-title="playlist_songs_no" :img-src="playlist_cover"
            img-alt="Image" img-top tag="article">
            <div class="w-100 text-center mt-3">
              <b-button variant="cutomer-primary" class="w-100 btn-bumblebee btn-doomyoga btn-doom-yoga-play"
                @click="playTrack(playlist_id, 0)">Play music</b-button>
            </div>
          </b-card>
        </b-col>
        <b-col xl="9" lg="8">
          <dataset :ds-data="tracks" :ds-search-in="['title', 'artist', 'album']" :ds-search-as="{ searchTest }">
            <dataset-show :ds-show-entries="entries" class="showEntriesSelectContainer float-right d-none" />
            <div class="row">
              <div class="col-md-12">
                <div class="row my-2">
                  <div class="col">
                    <h3 class="media-category-title">
                      Surround to Sound and Silence
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table doomYogaCustomerTable doomYogaPlaylistTable">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th>Title</th>
                        <th>Artist</th>
                        <th>Album</th>
                        <th>Duration</th>
                      </tr>
                    </thead>
                    <dataset-item tag="tbody">
                      <template #default="{ row, rowIndex }">
                        <tr @click="playTrack(playlist_id, rowIndex)">
                          <td scope="row">{{ rowIndex + 1 }}</td>
                          <td>
                            <!-- <img
                              v-if="row.cover_art_url == null"
                              src="@/assets/images/doom-yoga/doomyoga-music.png"
                            />
                            <img v-else :src="row.cover_art_url" /> -->
                            <img :src="row.track.album.images[0].url" />
                            <span> {{ row.track.name }} </span>
                          </td>
                          <td>{{ row.track.artists[0].name }}</td>
                          <td>{{ row.track.album.name }}</td>
                          <td>{{ convertMsToHM(row.track.duration_ms) }}</td>
                        </tr>
                      </template>
                      <template #noDataFound>
                        <tr>
                          <td colspan="5">
                            <p class="text-center datasetNoFoundP mb-0">
                              No data found
                            </p>
                          </td>
                        </tr>
                      </template>
                    </dataset-item>
                  </table>
                </div>
              </div>
            </div>

          </dataset>


        </b-col>
      </b-row>
    </b-card>

    <div class="music-player spotify-track-player-dy">
      <!-- the audio player code starts here -->
      <div class="player" id="player">
        <div class="container player-container">
          <div class="player-contents-wrap">
            <b-row>
              <b-col lg="3" md="4" class="track-data">
                <div class="album-art" v-if="currentSong != null">
                  <img :src="currentSong.album.images[0].url" class="img" />
                </div>
                <div class="title" v-if="currentSong != null">
                  <p class="trackTitle">{{ currentSong.name }}</p>
                  <p class="trackArtist">
                    {{ currentSong.artists[0].name }}
                  </p>
                </div>
              </b-col>
              <b-col lg="7" md="8">
                <div class="main-controls">
                  <div class="controls">
                    <button class="control-icon shuffle-icon" :class="{ active: is_playlist_shuffle == true }"
                      @click="clickShuffle">
                      <font-awesome-icon icon="fa-solid fa-shuffle" />
                    </button>
                    <button class="control-icon skip-backward" @click="playPrev">
                      <font-awesome-icon icon="fa-solid fa-backward-step" />
                    </button>

                    <button class="control-icon play">
                      <font-awesome-icon v-if="!is_playing" icon="fas fa-play" @click="playPauseTrack('play')" />
                      <font-awesome-icon v-if="is_playing" icon="fas fa-pause" @click="playPauseTrack('pause')" />
                    </button>
                    <!-- <button
                            class="control-icon play"
                            v-else
                            @click="pause"
                          >
                            <font-awesome-icon icon="fas fa-pause" />
                          </button> -->

                    <button class="control-icon skip-forward" @click="playNext">
                      <font-awesome-icon icon="fa-solid fa-forward-step" />
                    </button>

                    <button class="control-icon repeat" @click="clickRepeat">
                      <img v-if="repeat_status == 'off'" class="player-actions-img"
                        src="@/assets/images/doom-yoga/repeat-icon.png" alt="doomyoga Logo" />
                      <img v-if="repeat_status == 'context'" class="player-actions-img"
                        src="@/assets/images/doom-yoga/repeat-icon-active.png" alt="doomyoga Logo" />
                      <img v-if="repeat_status == 'track'" class="player-actions-img"
                        src="@/assets/images/doom-yoga/repeat-once-icon.png" alt="doomyoga Logo" />
                      <!-- <img
                              v-else-if="onRepeat && loop.value == '1'"
                              class="player-actions-img"
                              src="@/assets/images/doom-yoga/repeat-once-icon.png"
                              alt="doomyoga Logo"
                            /><img
                              v-else-if="onRepeat && loop.value == 'all'"
                              class="player-actions-img"
                              src="@/assets/images/doom-yoga/repeat-icon-active.png"
                              alt="doomyoga Logo"
                            /> -->
                    </button>
                    <button class="control-icon volume" @click="clickMute">
                      <font-awesome-icon icon="fa-solid fa-volume-high" v-if="!is_muted" />
                      <font-awesome-icon icon="fa-solid fa-volume-mute" v-if="is_muted" />
                      <!-- <font-awesome-icon
                              icon="fa-solid fa-volume-mute"
                              v-else-if="
                                audioPlayer != null && audioPlayer.muted == true
                              "
                            /> -->
                    </button>
                  </div>
                </div>
                <!-- <div v-if="currentSong != null">
                  {{ (current_state.position / currentSong.duration_ms) * 100 }}
                </div> -->
                <!-- progress and time-->
                <div class="seek">
                  <div class="title-and-time">
                    <div class="time" v-if="currentSong != null">
                      {{ convertMsToHM(current_state.position) }}
                    </div>
                  </div>

                  <div class="progress-container">
                    <b-progress height="4px" :value="currentSong != null ? (current_state.position /
                      currentSong.duration_ms) *
                      100 : '0'" class="progress-seek-spotify-dy"></b-progress>

                    <!-- <div class="progress" id="progress-wrap">
                      <div class="progress-handle" :style="[
                        currentSong != null
                          ? {
                            left:
                              (current_state.position /
                                currentSong.duration_ms) *
                              100 +
                              '%',
                          }
                          : { left: '0%' },
                      ]"></div>

                      <div class="transparent-seeker-layer"></div>

                      <div class="bar" :style="[
                        currentSong != null
                          ? {
                            width:
                              (current_state.position /
                                currentSong.duration_ms) *
                              100 +
                              '%',
                          }
                          : { width: '0%' },
                      ]"></div>
                    </div> -->
                  </div>
                  <div class="title-and-time">
                    <div class="time" v-if="currentSong != null">
                      {{ convertMsToHM(currentSong.duration_ms) }}
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
      <!-- the audio player code ends here -->
    </div>

    <!-- <audio
            
            ref="audiofile"
            :src="currentSong.url"
            preload
            style="display: none"
            controls
          ></audio> -->
  </div>
</template>

<script src="https://sdk.scdn.co/spotify-player.js"></script>

<script>
import MediaSimpleCardList from "@/components/media_components/MediaSimpleCardList.vue";
import {
  filterList,
  clone,
  isoDateToEuroDate,
  searchAsEuroDate,
} from "vue-dataset/docs/.vuepress/utilities";
import { debounce, fieldFilter, findAny } from "vue-dataset/src/helpers";
import axios from "axios";
import AudioPlaylistPlayer from "@/components/media_components/AudioPlaylistPlayer.vue";

import SpotifyNode from "spotify-web-api-node";
var ServerMethods = require("spotify-web-api-node/src/server-methods");
SpotifyNode._addMethods(ServerMethods);

import { convertMsToHMS } from "@/utils/helper-functions.js";
import { getSpotifyToken, getSpotifyAccessToken } from "@/utils/spotify-functions.js"

let tracks = [];

export default {
  name: "DoOmYogaCustomerMusicSpotifylaylist",
  components: { AudioPlaylistPlayer, MediaSimpleCardList },
  data() {
    return {
      login_user: window.localStorage.getItem("user"),
      user_name: "",
      entries: 100,


      playlist_title: "",
      playlist_cover: "",
      playlist_songs_no: "",

      tracks: [],
      defaultSong: null,
      currentSong: null,
      //  {
      //   id: 7,
      //   artist: "Benjamin Tissot",
      //   title: "Acoustic Breeze",
      //   album: "",
      //   url: "https://www.bensound.com/bensound-music/bensound-acousticbreeze.mp3",
      //   cover_art_url:
      //     "https://www.bensound.com/bensound-img/acousticbreeze.jpg",
      // },
      spotifyApi: null,
      authorizeURL: null,
      playlist_id: null,
      device_id: null,
      is_playing: false,
      current_playback_state: null,
      current_state: null,
      is_playlist_shuffle: false,
      repeat_status: "off",
      interval_state: null,
      is_muted: false
    };
  },

  created() {
    // this.innerLoop = this.loop.state;
    this.startWithInput = debounce((e) => {
      this.startsWith = e.target.value;
    }, 100);
  },
  async mounted() {
    // this.audioPlayer = this.$el.querySelectorAll("audio")[0];
    // this.initPlayer();

    await this.getSpotifyToken()
    this.spotifyApi = new SpotifyNode();
    this.spotifyApi.setAccessToken(
      localStorage.getItem("spotify_access_token")
    );

    tracks = [];
    this.tracks = [];

    this.getPlayListData(this.$route.params.id)

    var temp = this;

    console.log("before get device id in mounted");
    console.log(this.spotifyApi)

    await this.getSpotifyAccessToken()
    await this.spotifyApi.getMyDevices().then(
      function (data) {
        let availableDevices = data.body.devices;
        console.log("testttttt devices")
        console.log(data)
        console.log(availableDevices);
        if (availableDevices.length > 0) {
          temp.device_id = availableDevices[0].id;
        }
      },
      function (err) {
        console.log("Something went wrong!");
        console.log(err);
      }
    );
    console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");

    window.onSpotifyWebPlaybackSDKReady = () => {
      const token = localStorage.getItem("spotify_access_token");
      const player = new Spotify.Player({
        name: "Doom yoga test",
        getOAuthToken: (cb) => {
          cb(token);
        },
        // volume: 0.5,
      });
      console.log("player")
      console.log(player);

      // Error handling
      player.addListener("initialization_error", ({ message }) => {
        console.error(message);
      });
      player.addListener("authentication_error", ({ message }) => {
        console.error(message);
      });
      player.addListener("account_error", ({ message }) => {
        console.error(message);
      });
      player.addListener("playback_error", ({ message }) => {
        console.error(message);
      });

      // Ready
      player.addListener("ready", ({ device_id }) => {
        console.log("Ready with Device ID", device_id);
        temp.device_id = device_id;
      });

      // Not Ready
      player.addListener("not_ready", ({ device_id }) => {
        console.log("Device ID has gone offline", device_id);
      });
      player.addListener("initialization_error", ({ message }) => {
        console.error(message);
      });

      player.addListener("authentication_error", ({ message }) => {
        console.error(message);
      });

      player.addListener("account_error", ({ message }) => {
        console.error(message);
      });
      player.getVolume().then(volume => {
        let volume_percentage = volume * 100;
        // alert(`The volume of the player is ${volume_percentage}%`);
      });

      player.addListener(
        "player_state_changed",
        ({ position, duration, track_window: { current_track } }) => {
          console.log("Currently Playing", current_track);
          console.log("Position in Song", position);
          console.log("Duration of Song", duration);
          console.log(performance.now())
        }
      );

      // Connect to the player!
      player.connect().then((success) => {
        if (success) {
          console.log(
            "The Web Playback SDK successfully connected to Spotify!"
          );
        }
      });

      player.disconnect().then((success) => {
        if (success) {
          console.log(
            "The Web Playback SDK successfully disconnected to Spotify!"
          );
        }
      });
      // Playback status updates
      player.on("player_state_changed", (state) => {
        console.log(state);
        console.log(state.track_window.current_track);
        console.log(this.currentSong);
        temp.currentSong = state.track_window.current_track;
        temp.current_state = state;
        temp.current_state.updateTime = performance.now()
        console.log(temp.getStatePosition())
        console.log(this.currentSong);
        console.log("===========")

      });
      player.getCurrentState().then((state) => {
        if (!state) {
          console.error(
            "User is not playing music through the Web Playback SDK"
          );
          return;
        }

        var current_track = state.track_window.current_track;
        var next_track = state.track_window.next_tracks[0];

        console.log("***** Currently Playing", current_track);
        console.log("***** Playing Next", next_track);
      });
    };
  },
  updated() {
    console.log(this.currentSong);
  },
  watch: {
    is_playing(newval, oldval) {
      let temp = this
      if (newval) {
        temp.interval_state = setInterval(() => {
          // console.log( performance.now())
          // temp.getStatePosition()
          temp.getMyCurrentPlaybackState();
        }, 2000)
      } else {
        clearInterval(temp.interval_state)
      }
    }
  },
  methods: {
    getSpotifyToken, getSpotifyAccessToken,

    filterList,
    isoDateToEuroDate,
    searchAsEuroDate,
    // updateData() {
    //   const updatedList = clone(tracks).slice(5, 5);
    //   this.tracks = updatedList;
    // },
    startsWithFilter(value) {
      return (
        value === null ||
        value.toLowerCase().startsWith(this.startsWith.toLowerCase())
      );
    },
    searchTest(value, searchString, rowData) {
      console.log(value);
      console.log(searchString);
      console.log(rowData);
      console.log(searchString === value);
      return searchString === value;
    },
    fieldFilter,
    async getPlayListData(id) {
      await this.getSpotifyAccessToken();

      await axios
        .get("social/admin/playlists/" + id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.playlist_title = response.data.title
          this.playlist_id = response.data.playlist_id

          this.spotifyApi.setAccessToken(
            localStorage.getItem("spotify_access_token")
          );

          this.getPlaylist(this.playlist_id);
          this.getTracksOfPlaylist(this.playlist_id, 0, 100);

          // this.events = response.data;
          // this.setEventData(response.data);
        });
    },
    callFunctionsSpotify(is_call_function) {
      console.log(is_call_function);
      if (is_call_function) {
        // this.getPlaylistData(this.playlist_id)
        this.getPlaylist(this.playlist_id);
        this.getTracksOfPlaylist(this.playlist_id, 0, 100);
      }
    },

    getPlaylist(playlist_id) {
      var temp = this;
      this.spotifyApi.getPlaylist(playlist_id).then(
        function (data) {
          console.log("Some information about this playlist");
          console.log(data.body);
          temp.playlist_songs_no = data.body.tracks.total + " songs";
          temp.playlist_title = data.body.name;
          temp.playlist_cover = data.body.images[0].url;
        },
        function (err) {
          console.log("Something went wrong!", err);
        }
      );
      ////////
    },
    getStatePosition() {
      if (this.current_state.paused) {
        return this.current_state.position;
      }
      console.log(this.current_state.position)
      let position = this.current_state.position + (performance.now() - this.current_state.updateTime) / 1000;
      return position > this.current_state.duration ? this.current_state.duration : position;
    },

    getTracksOfPlaylist(playlist_id, offset, limit) {
      let temp = this;

      console.log(this.spotifyApi);
      console.log(temp.spotifyApi);

      temp.spotifyApi
        .getPlaylistTracks(playlist_id, {
          offset: offset,
          limit: limit,
        })
        .then(
          function (data) {
            console.log("The playlist contains these tracks", data.body);
            console.log(tracks);
            if (tracks.length == 0) {
              tracks = data.body.items;
              temp.tracks = tracks;
            } else {
              tracks = tracks.concat(data.body.items);
              temp.tracks = tracks;
            }
            console.log(tracks);
            temp.entries = tracks.length;
            if (data.body.next != null) {
              temp.getTracksOfPlaylist(
                playlist_id,
                data.body.items.length + offset,
                limit
              );
            } else {
            }
            temp.defaultSong = temp.tracks.length > 0 ? temp.tracks[0] : {};
            console.log(temp.defaultSong);
          },
          function (err) {
            console.log("Something went wrong!", err);
          }
        );
    },

    async playTrack(playlist_id, track_position) {
      console.log("---------------- play track position");
      await this.getSpotifyAccessToken();

      let temp = this;
      // Get a User's Available Devices
      console.log(temp.device_id);
      console.log(playlist_id, track_position);
      temp.spotifyApi
        .play({
          device_id: temp.device_id,
          context_uri: "spotify:playlist:" + playlist_id,
          offset: { position: track_position },
        })
        .then(
          function () {
            console.log("Playback played");

            temp.is_playing = true;

            setTimeout(function () {
              // temp.getCurrentPlaying();
              // temp.playPauseTrack("play");
            }, 5000);
          },
          function (err) {
            //if the user making the request is non-premium, a 403 FORBIDDEN response code will be returned
            console.log("Something went wrong! playyyy");
            console.log(err);
          }
        );
    },
    getCurrentPlaying() {
      console.log("in get current playing");
      let temp = this;
      this.spotifyApi.getMyCurrentPlayingTrack().then(
        function (data) {
          console.log(data);
          console.log(data.body);
          console.log("Now playing: " + data.body.item.name);
          temp.currentSong = data.body.item;
        },
        function (err) {
          console.log("Something went wrong!", err);
        }
      );
    },
    getMyCurrentPlaybackState() {
      // Get Information About The User's Current Playback State
      let temp = this;
      this.spotifyApi.getMyCurrentPlaybackState()
        .then(function (data) {
          // Output items
          console.log("------- get current state")
          console.log(data)
          if (data.body && data.body.is_playing) {
            console.log("User is currently playing something!");
          } else {
            console.log("User is not playing anything, or doing so in private.");
          }
          console.log(data.body.progress_ms)
          console.log(temp.current_state)
          console.log(data.body)
          temp.current_state.position = data.body.progress_ms
          console.log("----------------------")
        }, function (err) {
          console.log('Something went wrong!', err);
        });
    },
    async playPauseTrack(action) {
      console.log("in play/pause track");
      console.log(this.currentSong);

      let temp = this;
      console.log(temp.device_id);
      if (this.currentSong != null) {
        if (action == "play") {
          await this.spotifyApi
            .play({
              device_id: temp.device_id,
            })
            .then(
              function () {
                console.log("Playback played");
              },
              function (err) {
                //if the user making the request is non-premium, a 403 FORBIDDEN response code will be returned
                console.log("Something went wrong!", err);
              }
            );
          this.is_playing = true;
        } else if (action == "pause") {
          await this.spotifyApi
            .pause({
              device_id: temp.device_id,
            })
            .then(
              function () {
                console.log("Playback paused");
              },
              function (err) {
                //if the user making the request is non-premium, a 403 FORBIDDEN response code will be returned
                console.log("Something went wrong!", err);
              }
            );
          this.is_playing = false;
        }
      } else {
        this.playTrack(this.playlist_id, 0);
      }
    },
    playNext() {
      let temp = this;
      this.spotifyApi.skipToNext().then(
        function () {
          console.log("Skip to next");
          // temp.getCurrentPlaying();
        },
        function (err) {
          //if the user making the request is non-premium, a 403 FORBIDDEN response code will be returned
          console.log("Something went wrong!", err);
        }
      );
    },
    playPrev() {
      let temp = this;
      this.spotifyApi.skipToPrevious().then(
        function () {
          console.log("Skip to previous");
          // temp.getCurrentPlaying();
        },
        function (err) {
          //if the user making the request is non-premium, a 403 FORBIDDEN response code will be returned
          console.log("Something went wrong!", err);
        }
      );
    },
    async clickShuffle() {
      let temp = this;
      console.log("in click shuffle");
      await this.getCurrentPlaybackState();
      console.log(this.current_playback_state);
      console.log(this.current_playback_state.shuffle_state);

      let is_shuffle = this.current_playback_state.shuffle_state;
      this.spotifyApi.setShuffle(!is_shuffle).then(
        function () {
          console.log("Shuffle is ", !is_shuffle);
          temp.is_playlist_shuffle = !is_shuffle;
        },
        function (err) {
          //if the user making the request is non-premium, a 403 FORBIDDEN response code will be returned
          console.log("Something went wrong!", err);
        }
      );
    },
    async clickRepeat() {
      console.log("in click repeat");
      let new_repeat = "";
      if (this.repeat_status == "off") {
        new_repeat = "context";
      } else if (this.repeat_status == "context") {
        new_repeat = "track";
      } else if (this.repeat_status == "track") {
        new_repeat = "off";
      }

      let temp = this;

      // Set Repeat Mode On User’s Playback
      await this.spotifyApi.setRepeat(new_repeat).then(
        function () {
          console.log("Repeat ", new_repeat);
          temp.repeat_status = new_repeat;
        },
        function (err) {
          //if the user making the request is non-premium, a 403 FORBIDDEN response code will be returned
          console.log("Something went wrong!", err);
        }
      );
    },
    async clickMute() {
      let temp = this;
      let volume = 0
      if (!this.is_muted) {
        volume = 0
      } else {
        volume = 100
      }


      // Set Volume For User's Playback
      await this.spotifyApi.setVolume(volume)
        .then(function () {
          console.log('Setting volume to ' + volume);
          temp.is_muted = !temp.is_muted
        }, function (err) {
          //if the user making the request is non-premium, a 403 FORBIDDEN response code will be returned
          console.log('Something went wrong!', err);
        });

    },
    async getCurrentPlaybackState() {
      console.log("in get current playback state ");
      let temp = this;
      await this.spotifyApi.getMyCurrentPlaybackState().then(
        function (data) {
          console.log("get current playback state response")
          console.log(data);
          temp.current_playback_state = data.body;
          // Output items
          if (data.body && data.body.is_playing) {
            console.log("User is currently playing something!");
          } else {
            console.log(
              "User is not playing anything, or doing so in private."
            );
          }
        },
        function (err) {
          console.log("Something went wrong!", err);
        }
      );
    },
    convertMsToHM(millieseconds) {
      return convertMsToHMS(millieseconds);
    },
  },
};
</script>
<style scoped::v-deep >
@import "../../css/doom-yoga-audio-player-styles.css";
</style>


// WEBPACK FOOTER //
// src/components/doom_yoga/customer/Music/SpotifyPlaylistTracks.vue